import classNames from 'classnames';
import React from 'react';
import Tooltip from '../../common/components/core/Tooltip';

// SUBCOMPONENT OF CHECKBOX:
type LabelProps = {
  id: string;
  className?: string;
  disabled?: boolean;
  labelClickDisabled?: boolean;
  label?: any;
  tooltip?: string | any;
};

export const AuthCheckboxLabel = (props: LabelProps) => {
  let checkboxLabel: any = null;
  const textClassName = classNames('auth_check_box--label-text', {
    'auth_check_box--label-text-disable-click': props.labelClickDisabled,
  });

  if (props.label) {
    checkboxLabel = <span className={classNames(textClassName, props.className)}>{props.label}</span>;
  }

  if (props.label && props.tooltip) {
    checkboxLabel = (
      <span className={textClassName}>
        <span className="auth_check_box--popover-label">
          {props.label}
          <Tooltip body={props.tooltip} infoIconClassName="h_va-u" />
        </span>
      </span>
    );
  }

  return (
    <label
      className={classNames('auth_check_box--label', {
        disabled: props.disabled,
      })}
      htmlFor={`${props.id}-checkbox`}
    >
      {checkboxLabel}
    </label>
  );
};
